export const WEBSITE_LOADED = 'websiteLoaded';
